<template functional>
  <div class="social-wrapper">
    <img
      v-tooltip="`${props.title}`"
      :src="require(`../../../assets/img/social/${props.channel}.png`)"
      :alt="`${props.channel}`"
      :title="`${props.title}`"
      :style="`height: ${props.size}px; margin: ${props.size / 2}px;`"
    >
  </div>
</template>

<script>
import Vue from 'vue';
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

export default {
  name: 'SocialImage',
  props: {
    channel: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 29,
    },
  },
};
</script>

<style lang="scss" scoped >
  .social-wrapper {
    display: flex;

    img {
      min-width: 29px;
      min-height: 29px;
      align-self: center;
    }
  }
</style>
